import { NgModule } from "@angular/core";
import { WatchSizeRotateDirective } from "./watch-size-rotate";
import { IosWebTouchDetectDirective } from "./ios-touch-detect.directive";

@NgModule({
  imports: [
    IosWebTouchDetectDirective,
    WatchSizeRotateDirective,
  ],
  exports: [
    WatchSizeRotateDirective,
    IosWebTouchDetectDirective,
  ]
})
export class directivesModule { }
